import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'sumWeekMinutes'
})
export class SumWeekMinutesPipe implements PipeTransform {
    transform(weeks: {
        totaltime_decimal: number,
        assignment_decimal: number,
        week: number,
        year: number
    }[], field: 'totaltime_decimal' | 'assignment_decimal' | 'balance'): number {
        if (!weeks?.length) {
            return 0;
        }
        if (field === 'balance') {
            const now = new Date();
            const currentIsoYear = now.getFullYear();
            const startOfYear = new Date(currentIsoYear, 0, 1);
            const currentIsoWeek = Math.ceil(((now.getTime() - startOfYear.getTime()) / 86400000 + startOfYear.getDay() + 1) / 7);

            return weeks
                .filter(w => w.year < currentIsoYear || (w.year === currentIsoYear && w.week <= currentIsoWeek))
                .reduce((s, w) => s + (w.totaltime_decimal - w.assignment_decimal) * 60, 0);
        }
        return weeks.reduce((s, w) => s + w[field], 0) * 60;
    }
}

